// extracted by mini-css-extract-plugin
export default {"tab_container":"styles_tab_container__dMOif","tab_item":"styles_tab_item__65+Bo","active":"styles_active__2YVTv"};